import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import BannerAd from '../../../shared/components/BannerAd/BannerAd';
import { GlobalCancellationsDelays as globalCancellationsDelaysAds } from './ads';
import { addMetaCanonical } from '../../../shared/lib/meta-tags';
import BodyHeader from '../../../shared/components/BodyHeader/BodyHeader';

const title = 'FlightStats Global Cancellations and Delays';
const desktopLanguage = 'This visualization is too large for mobile browsers. Please view this page on a desktop browser.';

const metaTags = ({ pathname }) => {
  const description = 'The global flight cancellation and delay tracker from flightstats.com is the most trusted and comprehensive day-of-travel snapshot.';
  const keywords = 'airport delays, flight delays, delay trends, current flight delays, canceled flights, flight cancellations';
  const metaWithoutCanonical = {
    title,
    meta: [
      { name: 'description', content: description },
      { name: 'keywords', content: keywords },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
    ],
  };
  return addMetaCanonical(metaWithoutCanonical, pathname);
};

const GlobalCancellationsDelays = (props) => {
  const {
    user,
    location,
  } = props;

  const meta = metaTags(location);
  const { subscriptionActive } = user || {};

  const topAd = (
    <BannerAd
      topAd
      mobileAd={globalCancellationsDelaysAds.topMobile}
      desktopAd={globalCancellationsDelaysAds.top}
      subscriptionActive={subscriptionActive}
    />
  );

  return (
    <div>
      <div className='global-cancellations-delays-container'>
        <Helmet {...meta} />
        {topAd}
        <BodyHeader
          primary={title}
          primaryAlt={title}
        />
        <div className='pleaseUseDesktop'>
          <p>{desktopLanguage}</p>
        </div>
        <div className='globalCancellationsDelaysIframeDiv'>
          <iframe
            title={title}
            src='https://www.flightstats.com/go/Legacy/stats.do'
            width='984'
            height='1520'
          />
        </div>
      </div>
    </div>
  );
};

GlobalCancellationsDelays.propTypes = {
  location: PropTypes.object,
  user: PropTypes.object,
};

export default GlobalCancellationsDelays;



// WEBPACK FOOTER //
// ./modules/GlobalCancellationsDelays/components/container.js